import { LegalLayout } from "@/components/legal/LegalLayout";
import { useI18n } from "@/i18n";

export default function DataProcessing() {
  const { t } = useI18n();
  return <LegalLayout page="dpa" path="/data-processing" content={t("legal.dpa")} testid="data-processing-page" />;
}
